import React from 'react';

interface ClearPathLogoProps {
  variant?: 'dark' | 'white';
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export default function ClearPathLogo({ variant = 'dark', size = 'md', showText = false }: ClearPathLogoProps) {
  const sizes = {
    sm: { icon: 24, text: 'text-lg', gap: 'gap-2' },
    md: { icon: 32, text: 'text-xl', gap: 'gap-2.5' },
    lg: { icon: 40, text: 'text-2xl', gap: 'gap-3' },
  };
  const s = sizes[size];
  const invertClass = variant === 'white' ? 'brightness-0 invert' : '';
  const textColor = variant === 'white' ? 'text-white' : 'text-[#2D2A2E]';

  return (
    <div className={`flex items-center ${s.gap}`}>
      <img
        src="/logo-dark.png"
        // With the name beside it the mark is decoration; alone, it is the name.
        alt={showText ? '' : 'ClearPath'}
        width={s.icon}
        height={s.icon}
        className={`object-contain ${invertClass}`}
        style={{ width: s.icon, height: s.icon }}
      />
      {showText && (
        <span className={`font-serif font-medium ${s.text} ${textColor} tracking-tight leading-none select-none`}>
          ClearPath
        </span>
      )}
    </div>
  );
}
